import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { VehicleImageModel, VehicleModel } from '../models/vehicle.model';

@Injectable({
    providedIn: 'root'
})

export class VehicleService {
    // readonly apiURL = "http://localhost:52681/api";
    readonly apiURL = "https://api-megaautos.azurewebsites.net/api";

    constructor(private http: HttpClient) { }

    geAlltVehicles(onlyAvailable: boolean): Observable<any[]> {
        return this.http.get<any>(this.apiURL + '/vehicle/GetVehicle/' + onlyAvailable + '/0')
    }

    getVehicleById(idVehicle: any): Observable<any[]> {
        return this.http.get<any>(this.apiURL + '/vehicle/GetVehicle/false/' + idVehicle);
    }

    getVehicleImagesByIdVehicle(idVehicle: any): Observable<any[]> {
        return this.http.get<any>(this.apiURL + '/vehicle/GetVehicleImagesByIdVehicle/' + idVehicle);
    }

    saveVehicle(val: VehicleModel) {
        return this.http.post(this.apiURL + '/vehicle/saveVehicle', val);
    }

    saveVehicleImage(val: VehicleImageModel) {
        return this.http.post(this.apiURL + '/vehicle/saveVehicleImage', val);
    }

    deleteVehicleImage(idVehicleImage: any) {
        return this.http.delete(this.apiURL + '/vehicle/deleteVehicleImage/' + idVehicleImage);
    }
}
